import React from 'react'
import styles from './styles.module.css'
import cn from 'classnames'


export default function Input ({label, className, textareaClassName, highlight, ...props}) {
  return (
    <label className={cn(styles.label, className)}>
        <p className={cn({ [styles.greenLabel]: highlight })}>{label}</p>
        <textarea className={cn(styles.input, textareaClassName)} {...props}/>
        <p className={styles.errorText}>{props.error || ''}</p>
    </label>
  )
}
